import { PublishingV1InfoForm } from "./PublishingV1InfoForm";

export default PublishingV1InfoForm;
